export default __webpack_public_path__ + "static/media/amit.e0fbc1d8.png";